import { render } from "./flbQrCode.vue?vue&type=template&id=63b524aa&scoped=true"
import script from "./flbQrCode.vue?vue&type=script&lang=js"
export * from "./flbQrCode.vue?vue&type=script&lang=js"

import "./flbQrCode.vue?vue&type=style&index=0&id=63b524aa&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b524aa"]])

export default __exports__